module.exports=function(scope){ return `curl -X GET "https://your.internal.facetec.standard.server.instance.url/session-token"
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/bash/session-token.bash.tpl